const config = {
  supportEmail: 'giteam@morganstanley.com',
  aboutUsUrl:
    'https://www.morganstanley.com/atwork/global-intelligence-public-companies',
};

export default config;
